import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class BreadcrumbsDataService {
  public subCrumb: Subject<Crumb> = new Subject<Crumb>();
  public subSubCrumb: Subject<Crumb> = new Subject<Crumb>();

  public setSubCrumb(sub: Crumb): void {
    this.subCrumb.next(sub);
  }

  public setSubSubCrumb(sub: Crumb): void {
    this.subSubCrumb.next(sub);
  }

  public resetCrumb(): void {
    this.subCrumb.next(null);
    this.subSubCrumb.next(null);
  }
}

export interface Crumb {
  type: string;
  url: string;
  title: string;
}
